import {
  CreateInspectionStatusAccessRule,
  InspectionStatusAccessRule,
  InspectionStatusOption,
  UpdateInspectionStatusAccessRule,
} from '@/types';
import {
  Core,
  INSPECTION_STATUS_ACCESS_RULES,
  INSPECTION_STATUS,
} from '../Core';

class InspectionStatus extends Core {
  getStatuses = async () =>
    this.get<InspectionStatusOption[]>(INSPECTION_STATUS());

  getAccessRules = async () =>
    this.get<InspectionStatusAccessRule[]>(INSPECTION_STATUS_ACCESS_RULES());

  createAccessRule = async (data: CreateInspectionStatusAccessRule) =>
    this.post(INSPECTION_STATUS_ACCESS_RULES(), data);

  updateAccessRule = async (
    id: number,
    data: UpdateInspectionStatusAccessRule,
  ) => this.put(`${INSPECTION_STATUS_ACCESS_RULES()}/${id}`, data);

  removeAccessRule = async (id: number) =>
    this.delete(`${INSPECTION_STATUS_ACCESS_RULES()}/${id}`);
}

export const inspectionStatus = new InspectionStatus();
